import {
    AudienceMetadata,
    AudienceMetadataType,
} from '../types'
import {AudienceMetadataHeaderView} from './AudienceMetadataHeaderView'
import {MetadataView} from './MetadataView'
import React from 'react'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'


const StyledDelegateContainer = styled('div')
const StyledDelegateItems = styled('div', {marginLeft: '1.5em'})
const StyledItemSpace = styled('div', {'&:not(:first-child)': {marginTop: '1em'}})

export type DelegateMetadataViewProps = {
    compact?: boolean
    metadataType?: AudienceMetadataType
    delegates?: Array<AudienceMetadata>
}

export const DelegateMetadataView = ({
    compact,
    delegates,
    metadataType = 'ssoDelegate',
}: DelegateMetadataViewProps): React.ReactElement => {
    const {t} = useTranslation()

    const tDelegatesHeader = t('Acting as delegate for')
    return (
        <StyledDelegateContainer>
            <AudienceMetadataHeaderView text={tDelegatesHeader} values={{[tDelegatesHeader]: delegates as unknown as AudienceMetadata}} />
            <StyledDelegateItems>
                {delegates?.map((delegate, index) => {
                    const delegateKey = typeof delegate === 'object' && delegate !== null && 'Personal identity code' in delegate
                        ? String(delegate['Personal identity code'])
                        : `delegate-${index}`

                    return (
                        <StyledItemSpace key={delegateKey}>
                            <MetadataView
                                compact={compact}
                                key={delegateKey}
                                level={0}
                                metadata={delegate}
                                metadataType={metadataType}
                            />
                        </StyledItemSpace>
                    )
                })}
            </StyledDelegateItems>
        </StyledDelegateContainer>
    )
}

DelegateMetadataView.defaultProps = {
    compact: false,
    delegates: [],
    metadataType: 'ssoDelegate',
}
